/**
 * Manage breadcrump name
 */
const routes = {
    '/': 'Accueil',
    '/pages': 'Gestion des pages',
    '/posts': 'Gestion des article',
};
export default routes;



// WEBPACK FOOTER //
// ./src/routes.js